import { Popup } from './popup';

export type { ContentProps, PopupComponentProps, PopupProps, TriggerProps } from './types';

export { Popup };
// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default Popup;
